import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './components/about/about.component';
import { CampusComponent } from './components/campus/campus.component';
import { CommercialComponent } from './components/commercial/commercial.component';
import { HomeComponent } from './components/home/home.component';
import { ResidentialComponent } from './components/residential/residential.component';
import { EHouseComponent } from './components/e-house/e-house.component';

const routes: Routes = [
  { path: '', component: HomeComponent},
  { path: 'Home', component: HomeComponent},
  { path: 'About', component: AboutComponent },
  { path: 'Residential', component: ResidentialComponent },
  { path: 'Commercial', component: CommercialComponent },
  { path: 'Campus', component: CampusComponent },
  { path: 'EHouse', component: EHouseComponent }


];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
